const MyCollectionProtocol = require( './MyCollectionProtocol.js' );
const {TestData}           = require( '../view/TestData.jsx');

export const AddItemUtil = {
    listItemAdded: []
    , showItemAddSection: { S: false, P: false, B: false, M: false, C: false, G: false }
    , setOptionShowAddSection: function (showItemAdd, itemType) {
        itemType = itemType.toUpperCase();
        this.showItemAddSection[itemType] = showItemAdd;
    }
    , getOptionShowAddSection: function (itemType) {
        itemType = itemType.toUpperCase();
        if ( typeof this.showItemAddSection[itemType] == "undefined")
        {
            return [];
        }
        else
        {
            return this.showItemAddSection[itemType];
        }
    }
    , setItemAdded: function (itemAdded, itemType) {
        itemType = itemType.toUpperCase();
        this.listItemAdded[itemType] = itemAdded;
    }
    , getItemAdded: function (itemType) {
        itemType = itemType.toUpperCase();
        return (this.listItemAdded[itemType] == null) ? [] : this.listItemAdded[itemType];
    }
    , clearItemAdded: function (itemType) {
        itemType = itemType.toUpperCase();
        this.listItemAdded[itemType] = [];
    }
}

export const ItemInvUtil = {
    listItemInv: []
    , insItemInv: function( itemId, invData) {
        const listItemInv = this.listItemInv;
        for (const itemInv of listItemInv) {
            if (itemInv.itemId == itemId) {
                return;
            }
        }
        this.listItemInv[this.listItemInv.length] = {itemId: itemId, invData: invData};
        return;
    }
    , getItemInvData: function( itemId ) {
        const listItemInv = this.listItemInv;
        for (const itemInv of listItemInv) {
            if (itemInv.itemId == itemId) {
                return itemInv.invData;
            }
        }
        return null;
    }
}

export const MsgUtil = {
    getMsgListItemCount: function(itemTypeName,strKeyword,itemCnt) {
        let retMsg = "";
        if (strKeyword.trim() == "") {
            retMsg = itemTypeName;
        }
        else {
            retMsg = ( (itemCnt > 1)?"results":"result" ) + " for \"" + strKeyword + "\" in My " + itemTypeName;
        }
        return retMsg;
    }
}

export const CategoryUtil = {
    selectedCategory: {
            A: []
        ,   S: []
        ,   P: []
        ,   B: []
        ,   M: []
        ,   G: []
        ,   C: []
        }
    , strItemType: "SPMBCG"
    , clearCategoryFilter: function(itemType) {
        if ( !this.isItemTypeRight(itemType) ) return null;
        
        itemType = itemType.toUpperCase();
        this.selectedCategory[itemType] = [];
    }
    , getSelectedCategory: function(itemType) {
        if ( !this.isItemTypeRight(itemType) ) return [];

        itemType = itemType.toUpperCase();
        return this.selectedCategory[itemType];
    }
    , getSelectedCategoryMapping: function(itemType, listCategory) {  
        if ( !this.isItemTypeRight(itemType) ) return this.doCategoryMapping( [], listCategory);

        itemType = itemType.toUpperCase();
        const selectedCategory = ( (typeof this.selectedCategory[itemType] == "undefined") || (this.selectedCategory[itemType] == null) )?[]:this.selectedCategory[itemType];

        return this.doCategoryMapping( selectedCategory, listCategory);
    }

    , doCategoryMapping: function(listSelectedCategory, listItemCategory) {
        let retCategoryMapping = [];

        if ( ( typeof listItemCategory == "undefined") || ( listItemCategory === null ) ) return [];

        for (const category of listItemCategory) {
            let selected = false;
            for (const selectedCategoryId of listSelectedCategory) {
                if (selectedCategoryId == category.idCategory) 
                {
                    selected = true;
                    break;
                }
            } 
            retCategoryMapping.push({idCategory: category.idCategory, catName: category.catName, itemCnt: category.itemCnt, selected: selected });
        }
        return retCategoryMapping;
    }
    , addSelectedCategory: function(itemType, idCategory) {
        
        if ( !this.isItemTypeRight(itemType) ) return -99;
        if ( !this.isIdCategoryRight(idCategory) ) return -99;
        
        itemType = itemType.toUpperCase();
        idCategory = parseInt(idCategory);

        let tmpSelectedCategory = ( (typeof this.selectedCategory[itemType] == "undefined") || (this.selectedCategory[itemType] == null) )?[]:this.selectedCategory[itemType];
        
        if (tmpSelectedCategory.lengh > 0 ) 
        {
            for (const tmpCategoryId of tmpSelectedCategory) {
                if ( tmpCategoryId == idCategory ) return -1; // existing cat id
            }
        } 

        tmpSelectedCategory.push(idCategory);
        this.selectedCategory[itemType] = tmpSelectedCategory;
        return 1;
    }
    , removeSelectedCategory: function(itemType, idCategory) {
        let newSelectedCategory = [];

        if ( !this.isItemTypeRight(itemType) ) return -99;
        if ( !this.isIdCategoryRight(idCategory) ) return -99;
       
        itemType = itemType.toUpperCase();
        for (const tmpCategoryId of this.selectedCategory[itemType]) {
            if ( tmpCategoryId == idCategory ) continue;
            newSelectedCategory.push(tmpCategoryId);
        }
        this.selectedCategory[itemType] = newSelectedCategory;
        return 1;
    }
    , clearAllCategoryFilter: function() {
        this.selectedCategory = {A: [], S: [], P: [], B: [], M: [], G: [], C: []};
    }
    , isItemTypeRight: function(itemType) {
        if ( (itemType === null) || ( typeof itemType !== "string") ) return false;
        if ( this.strItemType.indexOf( itemType.toUpperCase()) == -1) return false;
        return true;
    }
    , isIdCategoryRight: function(idCategory) {        
        if (idCategory == null) return false;
        if ( idCategory != parseInt(idCategory) ) return false;
        
        idCategory = parseInt(idCategory);
        if ( isNaN(idCategory) || (idCategory <= 0) ) return false;
        
        return true;
    }


}

export const ItemListUtil = {
    iterId: 0
    , isEmptyList: function (listItem) {
        if (listItem === null) return true;
        for (const item of listItem) {
            if (item.invQty > 0) return false;
        }
        return true;
    }
    , increaseListIter: function () {
        
        this.iterId++;
    }
    ,  getListIterId: function() {
        return(this.iterId);
    }
    /*
    ,  getCntListItem(listItem) {
        let cntItem = 0;
        for (const item of listItem) {
            cntItem += item.invQty;
        }
        return cntItem;
    }
    */
}


export const ItemTypeNameUtil = {
    itemTypeName: { "A": "Items", "P": "Parts", "S": "Sets", "B": "Books", "M": "Minifigures", "G": "Gear", "C": "Catalogs" }
    , getItemTypeString: function (itemType, itemCnt) {
        return ((itemType == "All") ? "Item" : itemType) + ((itemType == "Gear") ? "" : ((itemCnt > 1) || (itemCnt == 0)) ? "s" : "");
    }
    , getFullName: function (itemType) {
        const itemTypeName = this.itemTypeName[itemType];
        if ( (typeof itemTypeName != "undefined") && (itemTypeName != null) ) 
            return itemTypeName;
        else
            return "";
    }
}

export const Page = {
    openItemDetailPage: function (itemType, itemNoSeq, itemColorId = -99) {
        const colorArg = (itemColorId >=0 )?"&C="+itemColorId:"";
        const clickURL = "//" + blapp.config.getHost("www") + "/v2/catalog/catalogitem.page?" + itemType + "=" + itemNoSeq + colorArg;
        window.location.href = clickURL;
    }
}

export const MyCollectionUtils = {
    getItemCountByItemType: function( invInfo, itemType ) {
        let retItemCnt = { itemCnt: 0, itemLotCnt: 0 };
		
        if ( (invInfo == null) || (itemType == null)) {
            retItemCnt = { itemCnt: 0, itemLotCnt: 0};
        }
        else {
            let itemCount = 0;
            let itemLotCount = 0;

            switch (itemType) {
                case "A":
                    itemCount = ( ( typeof invInfo.nAllItemCount == "undefined" ) || invInfo.nAllItemCount == null )?0:invInfo.nAllItemCount;
                    itemLotCount = ( ( typeof invInfo.nAllItemLotCount == "undefined" ) || invInfo.nAllItemLotCount == null )?0:invInfo.nAllItemLotCount;
                    retItemCnt = { itemCnt: itemCount, itemLotCnt: itemLotCount};
                    break;
                case "S":
                    itemCount = ( ( typeof invInfo.nSetCount == "undefined" ) || invInfo.nSetCount == null )?0:invInfo.nSetCount;
                    itemLotCount = ( ( typeof invInfo.nSetLotCount == "undefined" ) || invInfo.nSetLotCount == null )?0:invInfo.nSetLotCount;
                    retItemCnt = { itemCnt: invInfo.nSetCount, itemLotCnt: invInfo.nSetLotCount };
                    break;
                case "P":
                    itemCount = ( ( typeof invInfo.nPartCount == "undefined" ) || invInfo.nPartCount == null )?0:invInfo.nPartCount;
                    itemLotCount = ( ( typeof invInfo.nPartLotCount == "undefined" ) || invInfo.nPartLotCount == null )?0:invInfo.nPartLotCount;
                    retItemCnt = { itemCnt: invInfo.nPartCount, itemLotCnt: invInfo.nPartLotCount };
                    break;
                case "M":
                    itemCount = ( ( typeof invInfo.nMinifigureCount == "undefined" ) || invInfo.nMinifigureCount == null )?0:invInfo.nMinifigureCount;
                    itemLotCount = ( ( typeof invInfo.nMinifigureLotCount == "undefined" ) || invInfo.nMinifigureLotCount == null )?0:invInfo.nMinifigureLotCount;
                    retItemCnt = { itemCnt: invInfo.nMinifigureCount, itemLotCnt: invInfo.nMinifigureLotCount };
                    break;
                case "B":
                    itemCount = ( ( typeof invInfo.nBookCount == "undefined" ) || invInfo.nBookCount == null )?0:invInfo.nBookCount;
                    itemLotCount = ( ( typeof invInfo.nBookLotCount == "undefined" ) || invInfo.nBookLotCount == null )?0:invInfo.nBookLotCount;
                    retItemCnt = { itemCnt: invInfo.nBookCount, itemLotCnt: invInfo.nBookLotCount };
                    break;
                case "C":
                    itemCount = ( ( typeof invInfo.nCatalogCount == "undefined" ) || invInfo.nCatalogCount == null )?0:invInfo.nCatalogCount;
                    itemLotCount = ( ( typeof invInfo.nCatalogLotCount == "undefined" ) || invInfo.nCatalogLotCount == null )?0:invInfo.nCatalogLotCount;
                    retItemCnt = { itemCnt: invInfo.nCatalogCount, itemLotCnt: invInfo.nCatalogLotCount };
                    break;
                case "G":
                    itemCount = ( ( typeof invInfo.nGearCount == "undefined" ) || invInfo.nGearCount == null )?0:invInfo.nGearCount;
                    itemLotCount = ( ( typeof invInfo.nGearLotCount == "undefined" ) || invInfo.nGearLotCount == null )?0:invInfo.nGearLotCount;    
                    retItemCnt = { itemCnt: invInfo.nGearCount, itemLotCnt: invInfo.nGearLotCount };
                    break;
            }
        }
		return retItemCnt;
    }
}

export const CommonUtils = {
    getColorHexCode: function(color) {
        if ( (typeof color == "undefined") || (color == null) ) return "#FFFFFF";
        if ( !this.isValidColor(color) ) return "#FFFFFF";

        return (color.idColor <= 0)?"#FFFFFF":"#" + color.ci.strColorHex;
    },

    isValidColor: function(color) {
        if (color.idColor == null) return false;
        if ( (typeof color.ci == "undefined") || (color.ci == null) ) return false;
        if ( (typeof color.ci.strColorHex == "undefined") || (color.ci.strColorHex == null) ) return false;
        return true;
    },

    isEqualJSON: function(obj1, obj2) {
        const strObj1 = JSON.stringify(obj1);
        const strObj2 = JSON.stringify(obj2);
        
        return (strObj1 == strObj2)?true:false;
      }
      
}

export const ItemDetailInfo = {
    getInfo: function (item) {
        if (item == null) item = {};
        
        const itemName = (typeof item.itemName == "undefined")?"":blapp.util.decodeHtml(item.itemName);
        const itemNoSeq = this.getItemNoSeq(item.itemNo, item.itemSeq);
        const strItemCondition = this.getStrItemCondition(item);
        const invURL = (typeof item.itemType == "undefined")?"":"/catalogItemInv.asp?" + item.itemType + "=" + itemNoSeq;

        const catNames = (typeof item.catNames == "undefined")?"":item.catNames;
        const catIds = (typeof item.catIds == "undefined")?"":item.catIds;
        const itemColorName = this.getItemColorName(item);
        const itemColorId = this.getItemColorId(item);
        let ci = null;
        if (typeof item.invColorID != "undefined") {
            if (item.invColorID >= 0) {
                ci = blapp.color.get(item.invColorID);
            }
        }
        
        
        const bQtyUpdated = (typeof item.newQty == "undefined") ? false : (item.newQty != item.invQty) ? true : false;
        const bQtyError = (typeof item.newQty != "undefined") ? (item.newQty == "") ? true : (item.newQty.toString().length > 6) ? true : false : false;
        //const qty = ( (typeof item.newQty != "undefined") ? item.newQty : (typeof item.invQty != "undefined")?0:item.invQty;
        
        const qty = this.getQty(item);
        const bHasColor = (typeof item.listColor != "undefined")?(item.listColor.colorList.length > 0)?true:false:false;
        const note = (typeof item.note != "undefined")?(item.note.length > 0)?item.note:"":"";
        const newNote = (typeof item.newNote == "undefined")?note:item.newNote;
        const bNoteEnabled = (typeof item.editNote != "undefined")?item.editNote:false;
        const bNoteUpdated = (typeof item.newNote == "undefined") ? false : (item.newNote != note) ? true : false;
        const bMarkedAsDeletion = item.markedAsDeletion;
        let isRenderColorInfo = false;
        if ((ci != null) && ((item.itemType == "P") || (item.itemType == "M") || (item.itemType == "G") || (item.itemType == "A"))) {
            if (((item.itemType == "M") || (item.itemType == "G")) && (ci.idColor <= 0)) {
                isRenderColorInfo = false;
            }
            else {
                isRenderColorInfo = true;
            }
        }
        else {
            isRenderColorInfo = false;
        }

        return (
            {
                itemName: itemName
                , itemNoSeq: itemNoSeq
                , itemColorId: itemColorId
                , itemColorName: itemColorName
                , strItemCondition: strItemCondition
                , invURL: invURL
                , catNames: catNames
                , catIds: catIds
                , catString: (typeof item.catString == "undefined")?"":item.catString
                , ci: ci
                , bHasColor: bHasColor
                , bQtyUpdated: bQtyUpdated
                , bQtyError: bQtyError
                , qty: qty
                , thumbUrl: (typeof item.thumbUrl == "undefined")?"":item.thumbUrl
                , itemType: (typeof item.itemType == "undefined")?"":item.itemType
                , isRenderColorInfo: isRenderColorInfo
                , note: note
                , newNote: newNote
                , bNoteEnabled: bNoteEnabled
                , bNoteUpdated: bNoteUpdated
                , bMarkedAsDeletion: bMarkedAsDeletion
            }
        )
    }
    , getQty: function(item) {
        let qty = 0;
        if ( (typeof item.newQty == "undefined") || (item.newQty == null) ) {
            if ( (typeof item.invQty == "undefined") || (item.invQty == null) ) {
                qty = 0;
            }
            else {
                qty = item.invQty;
            }
        } else {
            qty = item.newQty;
        }
        return parseInt(qty);
    }

    , getItemColorId: function(item) {
        let itemColorId = -1;

		if ( (typeof item.invColorID != "undefined") && (item.invColorID != null) && (item.invColorID >= 0) )
		{
			if ( item.invColorID >= 0) 
			{
				return item.invColorID;
			}
		}
        return itemColorId;
    }
    
    , getItemColorName: function(item) {
        let itemColorName = "";

		if ( (typeof item.invColorID != "undefined") && (item.invColorID != null) && (item.invColorID >= 0) )
		{
			if ( item.invColorID >= 0) 
			{
				const	ci	= blapp.color.get( item.invColorID );
				itemColorName = ci.strColorName;
			}
		}
        return itemColorName;
    }
    , getItemNoSeq: function (itemNo, itemSeq) {
        let itemNoSeq;

        if (itemNo == null) return "";
        
        itemNoSeq = itemNo;

        if ( (itemSeq != null) && (itemSeq >= 1) ) {
            itemNoSeq = itemNoSeq + "-" + itemSeq;
        }
        return itemNoSeq;
    }

    , getStrItemCondition: function (item) {
        if (item == null) return "";
        const itemType = item.itemType;
        const invNew = (typeof item.invNew == "undefined")?"":item.invNew.toUpperCase();
        const invComplete = (typeof item.invComplete == "undefined")?"":item.invComplete.toUpperCase();

        let strItemCondition = (invNew == "N") ? "New" : (invNew == "U") ? "Used" : "";

        if (itemType == "S") {
            strItemCondition += (invComplete == "C") ? ", Complete" : (invComplete == "I") ? ", Incomplete" : (invComplete == "S") ? ", Sealed" : "";
        }
        return strItemCondition;
    }
}